import { useState } from "react";
import { useTranslation } from "react-i18next";
import SimpleButton from "../../../../components/disposables/buttons/SimpleButton";
import { ConfigurationComponentType } from "../../../../navigation/ConfigurationNavigator";
import styles from "./styles.module.css";

interface WifiConfStep1aScreenProps extends ConfigurationComponentType {}

export default function WifiConfStep1aScreen({
  currentScreenSetter,
}: WifiConfStep1aScreenProps) {
  const { t } = useTranslation();
  const [ssidName, setSsidName] = useState("");

  return (
    <div className={styles["wifi-conf-step-one-container"]}>
      <div>
        <p className={styles["wifi-conf-step-one-title"]}>{t("wifi_conf_step1a.step", "STEP 1a.")}</p>
        <p className={styles["wifi-conf-step-one-subtitle"]}>{t("wifi_conf_step1a.connecting_to", "Connecting Marty to")}</p>
        <p className={styles["wifi-conf-step-one-a-ssid-title"]}>{t("wifi_conf_step1a.ssid_label", "WiFi Network Name (SSID)")}</p>
        <input
          type="text"
          placeholder={t("wifi_conf_step1a.ssid_placeholder", "SSID") || "SSID"}
          className={styles["wifi-conf-step-one-a-ssid-input-field"]}
          value={ssidName}
          onChange={(e) => setSsidName(e.target.value)}
        />
      </div>
      <div className={styles["wifi-conf-step-one-bottom-buttons-container"]}>
        <SimpleButton title={t("wifi_conf_step1a.continue", "Continue")} onClick={() => currentScreenSetter("wifi-configuration-step-2", {ssid: ssidName})} />
      </div>
    </div>
  );
}
